// frontend/src/constants/developerConstants.js

// CREATE
export const DEVELOPER_CREATE_REQUEST = "DEVELOPER_CREATE_REQUEST";
export const DEVELOPER_CREATE_SUCCESS = "DEVELOPER_CREATE_SUCCESS";
export const DEVELOPER_CREATE_FAIL = "DEVELOPER_CREATE_FAIL";
// Reset leftover create success
export const DEVELOPER_CREATE_RESET = "DEVELOPER_CREATE_RESET";

// UPDATE
export const DEVELOPER_UPDATE_REQUEST = "DEVELOPER_UPDATE_REQUEST";
export const DEVELOPER_UPDATE_SUCCESS = "DEVELOPER_UPDATE_SUCCESS";
export const DEVELOPER_UPDATE_FAIL = "DEVELOPER_UPDATE_FAIL";
export const DEVELOPER_UPDATE_RESET = "DEVELOPER_UPDATE_RESET";

// DELETE
export const DEVELOPER_DELETE_REQUEST = "DEVELOPER_DELETE_REQUEST";
export const DEVELOPER_DELETE_SUCCESS = "DEVELOPER_DELETE_SUCCESS";
export const DEVELOPER_DELETE_FAIL = "DEVELOPER_DELETE_FAIL";
export const DEVELOPER_DELETE_RESET = "DEVELOPER_DELETE_RESET";

// READ single developer
export const DEVELOPER_DETAILS_REQUEST = "DEVELOPER_DETAILS_REQUEST";
export const DEVELOPER_DETAILS_SUCCESS = "DEVELOPER_DETAILS_SUCCESS";
export const DEVELOPER_DETAILS_FAIL = "DEVELOPER_DETAILS_FAIL";
export const DEVELOPER_DETAILS_RESET = "DEVELOPER_DETAILS_RESET";
